import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../components/common/Button";
import ErrorAlert from "../components/common/ErrorAlert";
import FormWrapper from "../components/common/FormWrapper";
import Input from "../components/common/Input";
import PasswordField from "../components/common/PasswordField";
import MathCaptcha from "../components/common/MathCaptcha";
import AuthShell from "../components/layout/AuthShell";
import { useAuth } from "../hooks/useAuth";
import { useMathCaptcha } from "../hooks/useMathCaptcha";
import { validateLogin } from "../utils/validators";

const initialValues = {
  username: "",
  password: "",
};

function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const captcha = useMathCaptcha();
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((currentValues) => ({ ...currentValues, [name]: value }));
    setErrors((currentErrors) => ({ ...currentErrors, [name]: "" }));
    setSubmitError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // 1. Validate existing form fields first
    const validationErrors = validateLogin(values);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // 2. Validate Math CAPTCHA
    if (!captcha.validateCaptcha()) {
      return;
    }

    try {
      setIsSubmitting(true);
      setSubmitError("");
      await login(values);
      captcha.generateCaptcha();
      navigate("/dashboard", { replace: true });
    } catch (error) {
      captcha.generateCaptcha();
      setErrors((currentErrors) => ({ ...currentErrors, ...error.fieldErrors }));
      setSubmitError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell>
      <FormWrapper
        /* footer={
          <p className="text-sm font-medium text-[#4a5568] dark:text-[#b6bfd1]">
            Need an account?{" "}
            <Link className="font-semibold text-[#b97a32] transition-colors hover:text-[#9f6829]" to="/register">
              Create one
            </Link>
          </p>
        } */
      >
        <form className="space-y-5" onSubmit={handleSubmit} noValidate>
          <Input
            label="Username"
            name="username"
            value={values.username}
            onChange={handleChange}
            placeholder="admin"
            error={errors.username}
            autoComplete="username"
          />
          <PasswordField
            label="Password"
            name="password"
            value={values.password}
            onChange={handleChange}
            placeholder="Enter password"
            error={errors.password}
            hint="Use your backend-issued login credentials."
            autoComplete="current-password"
          />

          <MathCaptcha captcha={captcha} />

          {submitError ? <ErrorAlert message={submitError} /> : null}

          <Button type="submit" className="w-full bg-[#111c33] hover:bg-[#0b1324] focus:ring-[#111c33]" size="lg" isLoading={isSubmitting}>
            Continue
          </Button>

          <div className="flex items-center justify-center">
            <Link className="text-xs font-bold text-[#7d8798] hover:text-[#b97a32]" to="/forgot-password">
              Forgot password?
            </Link>
          </div>
        </form>
      </FormWrapper>
    </AuthShell>
  );
}

export default LoginPage;


